module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-BoldIt-801a6361ed867177c37542235bcd9206.woff";